import { render, staticRenderFns } from "./LinksFooter.vue?vue&type=template&id=51916517&scoped=true&"
import script from "./LinksFooter.vue?vue&type=script&lang=js&"
export * from "./LinksFooter.vue?vue&type=script&lang=js&"
import style0 from "./LinksFooter.vue?vue&type=style&index=0&id=51916517&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51916517",
  null
  
)

export default component.exports